<template>
  <div>
    <b-row>
      <b-col class="text-right">
        <a href="javascript:void(0)" class="text-decoration-none">
          <span class="see-more-link">{{ title }}</span>
        </a>
      </b-col>
    </b-row>

    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide v-for="product in products" :key="product.id">
        <m-c301 :product="product"
                :digitalShoppingCartBadge="digitalShoppingCartBadge"
                :physicalShoppingCartBadge="physicalShoppingCartBadge"
        />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import {Swiper, SwiperSlide, directive} from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import {mapGetters} from "vuex";

export default {
  name: "FavoriteProducts100",
  components: {Swiper, SwiperSlide, directive},
  props: {
    firstCategory: {
      default: 'آخرین محصولات',
    },
    digitalShoppingCartBadge: {
      default: 'مشاهده و خرید',
    },
    physicalShoppingCartBadge: {
      default: 'مشاهده و خرید',
    },
    title:{
      type: String,
      default: "محبوب ترین ها"
    }
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 4,
        autoplay: {
          delay: 2000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          100: {
            slidesPerView: 1,
          },
          500: {
            slidesPerView: 1,
          },
          600: {
            slidesPerView: 2,
          },
          765: {
            slidesPerView: 3,
          },
          980: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          }
        }
      },
    };
  },
  computed: {
    ...mapGetters({
      products: 'Product/getFavoriteProducts',
    }),
  },
  async mounted() {
    await this.$store.dispatch('Product/getFavoriteProducts')
  }
};
</script>

<style scoped>
.slider-row {
  padding-top: 20px;
  margin-left: 30px;
  margin-right: 30px;
}

.slider-controls {
  border-bottom: 1px solid #c4c4c4;
}

</style>